import { render, staticRenderFns } from "./HoverChip.vue?vue&type=template&id=f3692ce8&scoped=true"
import script from "./HoverChip.vue?vue&type=script&lang=js"
export * from "./HoverChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3692ce8",
  null
  
)

export default component.exports